import CandidateDataGrid from "../../containers/jobApplication/DataGrid";

export default function JobApplicationListPage() {
  return <CandidateDataGrid />;
}
